<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { CkButton } from '@ck/ui'
import { logout } from '@ck/auth'
import logoUrl from '../../design-system/logo-ck.png'

defineProps<{ customerName: string }>()
const route = useRoute()
const router = useRouter()
</script>

<template>
  <header>
    <div class="brand">
      <img :src="logoUrl" alt="CK">
      <div><strong>Portal do Cliente</strong><span>Olá, {{ customerName || 'Cliente' }}.</span></div>
    </div>
    <div class="actions">
      <div class="switch">
        <button type="button" :class="{ active: route.name === 'home' }" @click="router.push({ name: 'home' })">Acompanhamento</button>
        <button type="button" :class="{ active: route.name === 'relatorio' }" @click="router.push({ name: 'relatorio' })">Relatório final</button>
      </div>
      <CkButton variant="ghost" class="logout" @click="logout">Sair</CkButton>
    </div>
  </header>
</template>

<style scoped>
header { display: flex; align-items: center; justify-content: space-between; padding: 18px max(24px, calc((100vw - 1100px) / 2)); border-bottom: 1px solid var(--ck-cream-300); background: var(--ck-cream-50); }
.brand { display: flex; align-items: center; gap: 10px; }
.brand img { width: 30px; height: 48px; object-fit: contain; }
.brand span { display: block; color: var(--ck-text-muted); font-size: 12px; }
.actions { display: flex; align-items: center; gap: 12px; }
.switch { display: flex; padding: 4px; border-radius: var(--radius-md); background: var(--ck-cream-200); }
.switch button { border: 0; padding: 9px 14px; border-radius: 8px; background: transparent; color: var(--ck-text-muted); font: inherit; cursor: pointer; }
.switch .active { background: var(--ck-cream-50); color: var(--ck-maroon-700); font-weight: 700; box-shadow: var(--shadow-sm); }
.logout { min-height: auto; padding: 8px 14px; color: var(--ck-text-muted); }
@media (max-width: 760px) {
  header { align-items: flex-start; flex-direction: column; gap: 16px; }
  .actions { width: 100%; flex-direction: column; align-items: stretch; }
  .switch { width: 100%; }
  .switch button { flex: 1; }
}
</style>
